module.exports = __webpack_public_path__ + "static/media/car-logo.62c658a9.png";